import { render, staticRenderFns } from "./create-label.vue?vue&type=template&id=6eaf8421&scoped=true&"
import script from "./create-label.vue?vue&type=script&lang=ts&"
export * from "./create-label.vue?vue&type=script&lang=ts&"
import style0 from "./create-label.vue?vue&type=style&index=0&id=6eaf8421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaf8421",
  null
  
)

export default component.exports